import { render, staticRenderFns } from "./YlmsItem.vue?vue&type=template&id=dcdac07c&scoped=true&"
import script from "./YlmsItem.vue?vue&type=script&lang=ts&"
export * from "./YlmsItem.vue?vue&type=script&lang=ts&"
import style0 from "./YlmsItem.vue?vue&type=style&index=0&id=dcdac07c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdac07c",
  null
  
)

export default component.exports